import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  AvailableClinicsResponseDTO,
} from 'dtos';
import {
  getApiERxPatientWebpageURL,
  getApiERxUserWebpageURL,
  getApiERxGetAvailableClinics,
} from 'endpoints';
import isNil from 'lodash/isNil';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';

export type PatientERxPageRequest = {
  patientId: number;
  dosespotMappingId: number;
};

export type UserERxPageRequest = {};

export function useERxPage(
  request: PatientERxPageRequest | UserERxPageRequest,
  enabled: boolean = false,
): UseQueryResult<string, Error> {
  const userInfo = useUserInfo();
  const eRxEnabled = userInfo?.flags?.haseRxCredentials ?? false;
  const patientId = 'patientId' in request ? request.patientId : undefined;
  const dosespotClinicMappingId = 'dosespotMappingId' in request ? request.dosespotMappingId : undefined;
  return useQuery<string, Error>({
    queryKey: ['erx-notifications', patientId, dosespotClinicMappingId],
    queryFn: async () => {
      const response = (isNil(patientId)
        ? await getApiERxUserWebpageURL()
        : await getApiERxPatientWebpageURL({ patientId, dosespotClinicMappingId }));

      return response.url ?? '';
    },
    enabled: enabled && eRxEnabled,
  });
}

export function useAvailableClinics(): UseQueryResult<AvailableClinicsResponseDTO, Error> {
  const userInfo = useUserInfo();
  const eRxEnabled = userInfo?.flags?.haseRxCredentials ?? false;
  return useQuery<AvailableClinicsResponseDTO, Error>({
    queryKey: ['erx-clinics'],
    queryFn: getApiERxGetAvailableClinics,
    enabled: eRxEnabled,
  });
}
